import { Scale } from "@pdfking/math"
import { HorizontalAlign } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"
import type { CalendarDesign } from "#internal"

import { Slice } from "../../layout/Slice"
import { Area } from "../Area"
import { PictureCover } from "../PictureCover"
import { PlannerWeek } from "../PlannerWeek"

/** Lubalin, a long perpetual desk planner: under a rule in the primary its
 * week undated, Monday to Saturday a column each, Sunday under Saturday; the
 * contact at its foot, the year on its right. */
export const Lubalin: CalendarDesign = {
  cover: PictureCover({}),
  page: ({ body, contact, language, short, year }) => {
    const pitch = Scale(short, 0.06)
    const [rule, week] = Slice.top(body, Scale(pitch, 0.08))
    const [right, left] = Slice.right(contact, Scale(contact.width, 0.3))
    return [
      Area.solid(rule),
      ...PlannerWeek(week, year, undefined, pitch, Scale(short, 0.02), language),
      Area.contact(left, false),
      Area.text(
        Slice.bottom(right, Scale(right.height, 0.7))[0],
        `${year}`,
        PALETTE.primary,
        HorizontalAlign.RIGHT
      ),
    ]
  },
  pages: "pad",
}
